// extracted by mini-css-extract-plugin
export default {"host":"MainMenuItemCaption_host__d59C1"};